import { useCallback, useContext, useEffect, useState } from "react";

import { stripeMicroService } from "@/shared/services/stripeMicroService";
import { GlobalContext, LoaderContext } from "../contexts/contexts";
import { logger } from "../loggerHelper";
import { HTTP_STATUS } from "@/config/constants";

type CustomerPortalContext = {
  loggedInUser?: {
    id?: string | number;
  };
  selectedBrand?: {
    is_white_label?: boolean;
  };
};

function useCustomerPortal() {
  const [isLoading, setIsLoading] = useState(false);

  const { loggedInUser, selectedBrand } = useContext(
    GlobalContext
  ) as CustomerPortalContext;
  const loader = useContext(LoaderContext);

  useEffect(() => {
    loader(isLoading);
  }, [isLoading, loader]);

  const navigateToCustomerPortal = useCallback(async () => {
    try {
      setIsLoading(true);
      const reqData = {
        user_id: loggedInUser?.id,
        return_url: `${window?.location?.origin}/dashboard`,
        is_white_label: selectedBrand?.is_white_label,
      };
      const res = await stripeMicroService.openCustomerPortal(reqData);

      if (res.status === HTTP_STATUS.OK && res.data?.result?.data?.url) {
        window.location.href = res.data?.result?.data?.url;
      }
    } catch (err) {
      logger.error("Error in navigateToCustomerPortal", { err });
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    }
  }, [loggedInUser?.id, selectedBrand?.is_white_label]);
  return { isLoadingCustomerPortal: isLoading, navigateToCustomerPortal };
}

export default useCustomerPortal;
